import { render, staticRenderFns } from "./backWhite.vue?vue&type=template&id=15e968ba&"
import script from "./backWhite.vue?vue&type=script&lang=ts&"
export * from "./backWhite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports